import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { gameInitialState } from './constants';
import type { Game } from 'shared-types/games';

export const gameSlice = createSlice({
  name: 'game',
  initialState: gameInitialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCurrentGame: (state, action: PayloadAction<Game | null>) => {
      state.currentGame = action.payload;
    },
    setPlayers: (state, action: PayloadAction<string[]>) => {
      state.players = action.payload;
    },
    clearGame: (state) => {
      state.loading = gameInitialState.loading;
      state.error = gameInitialState.error;
      state.currentGame = gameInitialState.currentGame;
      state.players = gameInitialState.players;
    },
  },
});

export const { setLoading, setError, setCurrentGame, clearGame, setPlayers } = gameSlice.actions;

export default gameSlice.reducer;
